import * as React from "react";
import { faClock, faHashtag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatUserCode, secondsToHms } from "@audacia-hq/shared/utils";
import SharedComponents from "@audacia-hq/shared/components";
import { useTranslation } from "react-i18next";

import { useMember } from "../../context/MemberContext";

interface Props {
  className?: string;
}

const MemberCodeTime: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation("common");
  const { member } = useMember();

  const remaining = secondsToHms(member?.profile?.remainingTime || 0);

  return (
    <div className={`w-full flex justify-center space-x-6 md:space-x-12 py-2 ${className}`}>
      <div className="inline-flex items-center cursor-default">
        <SharedComponents.Tooltip
          position="bottom"
          className="w-64"
          arrow
          message={t("memberCodeTips")}
        >
          <FontAwesomeIcon icon={faHashtag} className="mr-2 hidden sm:inline" />
          {t("code")}
          <span className="text-green-500 ml-1 font-semibold">
            {
              member?.profile.memberCode
                ? formatUserCode(member.profile.memberCode, { padLength: 8, padChar: "0", format: "4 4" })
                : ""
            }

          </span>
        </SharedComponents.Tooltip>
      </div>
      <div className="inline-flex items-center cursor-default">
        {member && (
          <>
            <SharedComponents.Tooltip
              position="bottom"
              className="w-64"
              arrow
              message={t("memberRemainingTimeTips")}
            >
              <FontAwesomeIcon icon={faClock} className="mr-2 hidden sm:inline" />
              {t("time")}
              <span className={`${remaining.isNegative() ? "text-red-500" : "text-green-500"} ml-1 font-semibold`}>
                {remaining.toTimeString(t)}
              </span>
            </SharedComponents.Tooltip>
          </>
        )}
      </div>
    </div>
  );
};

export default MemberCodeTime;
